import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const ReasonCodesPopup = () => {
    const [items, setItems] = useState([]);
    const [freshRows, setFreshRows] = useState([]);
    const [ambientRows, setAmbientRows] = useState([]);
    const { reasonCodesResponse } = useSelector(state => state.reasonCodes);
    const { reasonCodes } = reasonCodesResponse;
    
    useEffect(() => {
        setItems(reasonCodes);

        const filterUniqueReasonCode = (items) => {
            const seenFresh = new Set();
            const seenAmbient = new Set();
            const uniqueReasonCodes = [];
          
            items?.forEach(entry => {
              const { reasonCode, productType } = entry;
          
              if (productType === 'Fresh') {
                if (!seenFresh.has(reasonCode)) {
                  seenFresh.add(reasonCode);
                  uniqueReasonCodes.push(entry);
                }
              } else if (productType === 'Ambient') {
                if (!seenAmbient.has(reasonCode)) {
                  seenAmbient.add(reasonCode);
                  uniqueReasonCodes.push(entry);
                }
              }
            });
          
            return uniqueReasonCodes;
          };
        const generatedFresh = [];
        const generatedAmbient = [];
        const filteredData = filterUniqueReasonCode(items);
        filteredData.forEach(item => {
            if (item.productType === "Fresh") {
                generatedFresh.push(
                    <tr key={item.reasonCode} >
                        <td style={{ border: '1px solid black', padding: '10px' }}>{item.reasonCode}</td>
                        <td style={{ border: '1px solid black', padding: '10px' }}>{item.description}</td>

                    </tr>
                );

            } else {
                generatedAmbient.push(
                    <tr key={item.reasonCode} >
                        <td style={{ border: '1px solid black', padding: '10px' }}>{item.reasonCode}</td>
                        <td style={{ border: '1px solid black', padding: '10px' }}>{item.description}</td>

                    </tr>
                );
            }
        });

        setFreshRows(generatedFresh.sort((a, b) => (a.key - b.key)));
        setAmbientRows(generatedAmbient.sort((a, b) => (a.key - b.key)));

    }, [reasonCodes, items]);

    return (
        <div style={{ margin: '20px' }}>

            <h2>Ambient</h2>
            <table style={{ width: '90%', height: '80px', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ border: '1px solid black', padding: '10px', backgroundColor: '#f2f2f2' }}>Reason Code</th>
                        <th style={{ border: '1px solid black', padding: '10px', backgroundColor: '#f2f2f2' }}>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {ambientRows}
                </tbody>
            </table>

            <h2>Fresh</h2>
            <table style={{ width: '90%', height: '80px', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={{ border: '1px solid black', padding: '10px', backgroundColor: '#f2f2f2' }}>Reason Code</th>
                        <th style={{ border: '1px solid black', padding: '10px', backgroundColor: '#f2f2f2' }}>Description</th>
                    </tr>
                </thead>
                <tbody>

                    {freshRows}
                </tbody>
            </table>

        </div>


    );
};
export default ReasonCodesPopup;